import React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

const CustomSocialButton = styled((props: any) => (
  <Button variant="contained"  color="inherit" {...props} />
))(({ theme }) => ({
  '&:hover': {
    color: theme.palette.white,
  },
}));

export default CustomSocialButton;
